import type { FaireProductEntity } from "../../entity_types/product";

export const p_wsfrgtzgva: FaireProductEntity = {
  token: "p_wsfrgtzgva",
  type: "product",
  name: "Sulla Honey",
  brandToken: "b_cswuxgoe1w",
  brandName: "Bona Furtuna",
  imageUrl: "https://cdn.faire.com/fastly/6087498aef7e7c66df1b0512be76fa09082ed03bd9e302fa6b079334437e8338.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7128f4957564b24b8a550043e11c52056667bb876c3aaeed09c5ca38f02e2a62.png",
    "https://cdn.faire.com/fastly/3513ff3439f94097071f987d89a9aa970fbe1d16b34c0d6eac3c881cfe790291.jpeg"
  ],
  priceDollars: 5.48,
  description: "Spotting the Sicilian landscape with bursts of pink, Sulla flowers produce a famously creamy, luscious honey with a light, fruity and floral sweetness. Enjoy the distinct Sulla flavors carried through this organic honey based entirely on the pollen harvested by our bees.",
  tags: [],
  msrpDollars: 10.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:24.356Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
